import { render, staticRenderFns } from "./CloseTicket.vue?vue&type=template&id=45628aba&scoped=true&"
import script from "./CloseTicket.vue?vue&type=script&lang=ts&"
export * from "./CloseTicket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45628aba",
  null
  
)

export default component.exports